import styled from 'styled-components'

export const StateAlert = styled.div`
  margin-top: 16px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #e7f3fe;
  color: #363636;
  font-size: 14px;
  svg {
    color: #213f68;
    margin-right: 10px;
  }
`
